module.exports = __webpack_public_path__ + "static/media/NuoMaiChi.f1d1c59f.jpg";